import { KeyValuePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { Store } from '@ngrx/store';

import { selectDocumentsList } from '@lib/medical-documents/core/store/medical-documents.selectors';

import { MedicalDocumentItem } from '../../../core/models/document.interface';
import { formatDocumentsByYear, sortYearsDescending } from '../../../core/utils/document-formatters';
import { ListItemComponent } from './list-item/list-item.component';

@Component({
  selector: 'md-list',
  standalone: true,
  imports: [ListItemComponent, KeyValuePipe],
  template: `
    <div class="space-y-4">
      @for (item of formattedDocuments() | keyvalue: reverseOrder; track item.key) {
        <div>
          <h3 class="text-gray-700 mb-2 text-sm font-semibold">{{ item.key }}</h3>
          <div class="flex flex-col gap-1">
            @for (document of item.value; track document.documentId) {
              <md-list-item [document]="document"></md-list-item>
            }
          </div>
        </div>
      }
    </div>
  `,
  styles: `
    :host {
      @apply h-full;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentsListComponent {
  private readonly store = inject(Store);

  documents = this.store.selectSignal<MedicalDocumentItem[]>(selectDocumentsList);

  formattedDocuments = computed(() => formatDocumentsByYear(this.documents()));

  protected reverseOrder = sortYearsDescending;
}
